module.exports = __webpack_public_path__ + "static/media/portfolio-banner-info-img3.61846d07.png";